<template>
  <div class="gm-ru">
    <label v-if="users.length > 8" class="rd-search gm-ru__search">
      <v-icon size="16" color="#5f5852">mdi-magnify</v-icon>
      <span class="rd-visually-hidden">{{ $t("search") }}</span>
      <input v-model="query" type="search" :placeholder="$t('search')" />
    </label>

    <report-state
      v-if="!users.length"
      icon="mdi-account-off-outline"
      :title="$t('no_users_found')"
    ></report-state>
    <report-state
      v-else-if="!shown.length"
      icon="mdi-account-off-outline"
      :title="$t('report_mobile.no_results_for', { search: query })"
    ></report-state>

    <ul v-else class="ui-card rd-card gm-ru__list">
      <li v-for="user in shown" :key="user.id" class="gm-ru__row">
        <span class="ui-avatar ui-avatar--neutral">{{ user.initials }}</span>
        <span class="gm-ru__text">
          <span class="gm-ru__name">{{ user.name }}</span>
          <span class="rd-muted rd-num gm-ru__meta">{{ user.meta }}</span>
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
import ReportState from "../../ReportState.vue";

/** Panel "Radnici koji su naručili" (iz Rezervnih obroka jela iz grupa): radnici jedne firme koji su u odgovoru. */
export default {
  name: "ReportDesktopGroupReservedUsers",
  components: { ReportState },
  props: {
    /** [{ id, name, lastname, email }] */
    items: { type: Array, default: () => [] },
  },
  data: () => ({
    query: "",
  }),
  computed: {
    users() {
      return this.items.map((user) => ({
        id: user.id,
        name: [user.name, user.lastname].filter(Boolean).map(this.toLatin).join(" "),
        initials: [user.name, user.lastname]
          .filter(Boolean)
          .map((part) => this.toLatin(part).charAt(0))
          .join(""),
        meta: [`ID ${user.id}`, user.email].filter(Boolean).join(" · "),
      }));
    },
    shown() {
      const query = this.query.trim();
      return query ? this.customSearch(this.users, [{ value: "name" }, { value: "meta" }], query) : this.users;
    },
  },
};
</script>

<style lang="scss">
.gm-ru {
  display: grid;
  gap: 12px;

  &__search {
    width: 100%;
  }

  &__list {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  &__row {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 16px;
    border-bottom: 1px solid var(--rm-divider-soft);

    &:last-child {
      border-bottom: none;
    }
  }

  &__text {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
  }

  &__name {
    font-size: 14px;
    font-weight: 600;
    overflow-wrap: anywhere;
  }

  &__meta {
    font-size: 12px;
    overflow-wrap: anywhere;
  }
}
</style>
